import React from "react";
import {styled, Typography, ThemeProvider, useTheme} from "@mui/material";

const StyledTypography = styled(Typography)(({theme, variant}) => ({
    marginBottom: theme.spacing(1), 

    ...(variant === 'h1' && {
        //
    }),
    ...(variant === 'h2' && {
        //
    }),
    ...(variant === "h3" && {
        fontWeight: 700,
        fontSize: 26
    }),
    ...(variant === 'h6' && {
        //
    }),
    ...(variant === 'subtitle1' && {
        //
    }),
    ...(variant === "subtitle2" && {
        fontSize: 16,
        fontWeight: 400,
    }),
    ...(variant === 'body1' && {
        //
    }),
    ...(variant === 'caption' && {
        //
    }),
}));

const CustomTypography = ({variant, text, customStyles, ...props}) => {
    const theme = useTheme();

    return (
        <ThemeProvider theme={theme}>
            <StyledTypography 
                variant={variant} 
                sx={{
                    ...customStyles
                }}  
                {...props}
                dangerouslySetInnerHTML={{__html: text}} 
            />
        </ThemeProvider>
    )
}

export default CustomTypography